import { toSeoUrl } from '.';
import { flatTypeDict } from '../model/enums/flatType.enum';

export const canonizeFlatType = (flatType: string): string => {
  return flatType ? flatType.replace(/ /g, '_').toUpperCase() : null;
};

export const getFlatTypeLabel = (flatType: string, plural = false): string => {
  return `enums.flatType.${canonizeFlatType(flatType)}.${
    plural ? 'plural' : 'singular'
  }`;
};

export const getFlatTypeSlug = (flatType: string, plural = false): string => {
  let auxFlatType = canonizeFlatType(flatType);
  if (flatTypeDict.hasOwnProperty(auxFlatType)) {
    return plural
      ? flatTypeDict[auxFlatType].plural
      : flatTypeDict[auxFlatType].singular;
  }

  return toSeoUrl(flatType);
};

export const getFlatTypeFromSlug = (slug: string): string => {
  const inverseDictSingular = Object.entries(flatTypeDict)
    .map(([key, value]) => ({ [value.singular]: key }))
    .reduce((previous, current) => ({ ...previous, ...current }), {});
  if (inverseDictSingular.hasOwnProperty(slug)) {
    return inverseDictSingular[slug];
  }

  const inverseDictPlural = Object.entries(flatTypeDict)
    .map(([key, value]) => ({ [value.plural]: key }))
    .reduce((previous, current) => ({ ...previous, ...current }), {});
  if (inverseDictPlural.hasOwnProperty(slug)) {
    return inverseDictPlural[slug];
  }

  return null;
};
